const Web3 = require('web3')

const network_address =
  'https://ropsten.infura.io/v3/96622c420b9e4d1aafc9120ab9226156'
const provider = new Web3.providers.HttpProvider(network_address)

const web3 = new Web3(provider)

module.exports = web3
